'use strict';

var baseTable = require('./base-table.json');

var varintEncode = require('./util').varintEncode; // map for codecName -> codeVarintBuffer


var varintTable = {};

for (var encodingName in baseTable) {
  var code = baseTable[encodingName];
  varintTable[encodingName] = varintEncode(code);
}

module.exports = Object.freeze(varintTable);